package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun ScorchingRayMetadata() {
    SpellMetadata(
        spellIndex = "scorching-ray",
        castingTime = "1 action",
        range = "120 feet",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC),
        material = null,
        duration = "Instantaneous",
        damageBase = "Fire 2d6",
        damageScaling = null,
        savingThrow = null,
        aoe = null,
        concentration = false
    )
}
